export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7536.a3cf96ad.jpg";